import "@hotwired/turbo-rails"
import "preline"

import { startConfirm } from "./lib/confirm"
startConfirm()

import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

import lightboxController from "./controllers/lightbox_controller"
application.register("lightbox", lightboxController)

import Disclosure from "./controllers/disclosure_controller"
application.register("disclosure", Disclosure)

document.addEventListener("turbo:render", () => {
  // Ensure Preline dropdowns are initialized
  reloadHSinits();
});

function reloadHSinits() {
  if (typeof HSDropdown !== "undefined") {
    HSDropdown.autoInit();
  }
  if (typeof HSTabs !== "undefined") {
    HSTabs.autoInit();
  }
  if (typeof HSTooltip !== "undefined") {
    HSTooltip.autoInit();
  }
  if (typeof HSTreeView !== "undefined") {
    HSTreeView.autoInit();
  }
  if (typeof HSAccordion !== "undefined") {
    HSAccordion.autoInit();
  }
}